<template>
  <div id="chatbox" :class="{ show: isVisible, hide: !isVisible }">
    <template v-if="isVisible">
      <div class="header">
        <span class="service-icon"></span>
        <span class="service-name">客服小助手</span>
        <div class="close-icon" @click="toggleVisible"></div>
      </div>
      <div ref="content" class="content">
        <template v-for="(message, index) in messages">
          <div
            class="date-wrapper"
            v-if="shouldShowDate(message, index)"
            :key="`date-${index}`"
          >
            <div class="date-box">
              {{ message.createDate }}
            </div>
          </div>
          <div
            :key="index"
            class="message"
            :class="{ 'message--reply': message.reply }"
          >
            <div class="message__body">{{ message.content }}</div>
            <div class="message__time">{{ message.createTime }}</div>
          </div>
        </template>
        <div v-if="loading" class="loading-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="footer">
        <textarea
          v-model="message"
          placeholder="輸入訊息..."
          @compositionstart="isTyping = true"
          @compositionend="isTyping = false"
          @keydown.enter="sendMessage"
        />
        <button type="button" :disabled="loading" @click="sendMessage">
          發送
        </button>
      </div>
    </template>
    <template v-else>
      <div class="chat-icon" @click="toggleVisible">
        <img src="@/assets/images/chat-icon.png" alt="chat" />
      </div>
    </template>
  </div>
</template>

<script>
// import { sendMessageToRemote } from "@/api";
// import Echo from "laravel-echo";
const wsUrl = process.env.VUE_APP_API_URL;
let websocket = new WebSocket(wsUrl);
export default {
  data() {
    return {
      message: "",
      loading: false,
      isVisible: false,
      sendMessageCount: 0,
      isTyping: false, // 是否正在打字
      idleTimer: null, // 計時器(用來計算是否為閒置狀態)
    };
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    },
    lastSendMessages() {
      const onlySenderMessages = this.$store.getters.onlySenderMessages;

      if (!onlySenderMessages.length) {
        return [];
      }

      if (this.sendMessageCount === 0) {
        return [onlySenderMessages[onlySenderMessages.length - 1]];
      }

      // 透過 sendMessageCount 取得發送過的訊息
      return onlySenderMessages.slice(-(this.sendMessageCount + 1));
    },
  },
  watch: {
    // 視窗預設值會在最下面
    isVisible() {
      if (this.isVisible) {
        this.$nextTick(() => {
          this.scrollToContentBottom();
        });
      }
    },
    messages() {
      this.$nextTick(() => {
        this.scrollToContentBottom();
      });
    },
    loading(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.scrollToContentBottom();
        });
      }
    }
  },
  mounted() {
    // websocket.onopen = function(evt) {
    //   this.onOpen(evt)
    // }.bind(this);
    //
    // websocket.onmessage = function(evt) {
    //   this.onMessage(evt)
    // }.bind(this);
    //
    // websocket.onclose = function(evt) {
    //   this.onClose(evt)
    // }.bind(this);

    // socket.io 目前無解
    // window.io = require("socket.io-client");
    // window.Echo = new Echo({
    //   broadcaster: "socket.io",
    //   host: "backend-k3si2zai5q-de.a.run.app",
    //   path: "/aicustservice/ws",
    //   transports: ['websocket'],
    //   enabledTransports: ['ws', 'wss'],
    // });

    if (!this.messages.length) {
      this.$store.dispatch("createMessage", {
        reply: true,
        content: "您好，我是AI智能客服阿秋，請輸入您想問的問題。",
      });
    }
  },
  methods: {
    // onOpen(evt) {
    //   this.writeToScreen("CONNECTED");
    // },
    // onClose(evt) {
    //   this.writeToScreen("DISCONNECTED");
    // },
    // onMessage(evt) {
    //   const responseData = JSON.parse(evt.data);
    //   this.$store.dispatch("createMessage", {
    //     reply: true,
    //     content: responseData.ResponseText,
    //   });
    // },
    // writeToScreen(evt) {
    //   console.log(evt);
    // },
    shouldShowDate(currentMessage, index) {
      if (index === 0) {
        if (currentMessage.createDate) {
          return true;
        } else {
          return false;
        }
      } else {
        const previousMessage = this.messages[index - 1];
        return currentMessage.createDate !== previousMessage.createDate;
      }
    },
    resetTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(() => {
        websocket.send("1");
      }, 300000); // 5 minute
    },
    async sendMessage(event) {
      if (this.loading) {
        return;
      }
      if (!this.message || this.message.trim() === "") {
        return;
      }

      if (event.key === 'Enter' && event.shiftKey) {
        return;
      }

      if (this.isTyping){
        return;
      }

      // 檢查 WebSocket 連線是否開啟
      if (websocket.readyState !== WebSocket.OPEN) {
        // 如果連線已經關閉，創建一個新的連線
        websocket = new WebSocket(wsUrl);

        // 等待新的 WebSocket 連線開啟
        await new Promise(resolve => {
          websocket.onopen = resolve;
        });
      }

      this.resetTimer();

      event.preventDefault(); // 防止觸發默認的 Enter 鍵事件

      await this.$store.dispatch("createMessage", {
        content: this.message,
      });

      this.loading = true;
      websocket.send(this.message);
      this.message = "";

      try {
        websocket.onmessage = async (evt) => {
          const response = JSON.parse(evt.data);
          const responseText = response.ResponseText;

          switch (response.ResponseType) {
            case "system":
              break;
            case "connect":
              await this.$store.dispatch("createMessage", {
                reply: true,
                content: responseText,
              });
              break;
            case "disconnect":
              await this.$store.dispatch("createMessage", {
                reply: true,
                content: "目前已一段時間無對話，阿秋先離開囉，有需要可以再找我，謝謝您！",
              });
              this.loading = false;
              break;
            default:
              await this.$store.dispatch("createMessage", {
                reply: true,
                content: responseText,
              });
              this.loading = false;
              break;
          }
        };

        this.sendMessageCount++;

        if (this.sendMessageCount > 2) {
          this.sendMessageCount = 0;
        }
      } catch (error) {
        await this.$store.dispatch("createMessage", {
          reply: true,
          content: "哎呀，出了點問題，請等等再試。",
        });

        this.loading = false;
      }
    },
    simulateReply() {
      return new Promise((resolve) => {
        setTimeout(() => {
          // 这里可以根据需要生成回复内容
          resolve("这是一个自动回复");
        }, 1000); // 延迟1秒来模拟回复
      });
    },
    toggleVisible(event) {
      event.stopPropagation();
      this.isVisible = !this.isVisible;
    },
    scrollToContentBottom() {
      if (this.$refs && this.$refs.content) {
        const content = this.$refs.content;
        content.scrollTop = content.scrollHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #f0f0f0;
$primary-color: #0047ff;

#chatbox {
  position: fixed;
  right: 10px;
  bottom: 115px;
  z-index: 9999;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI Adjusted","Segoe UI","Liberation Sans",sans-serif;
  @media screen and (max-width: 576px) {
    right: 1rem;
  }
}

#chatbox.show {
  width: 400px;
  border: 1px solid $border-color;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 576px) {
    width: 100%;
    right: 0;
    bottom: 0;
  }

  > .header {
    display: flex;
    padding: 9px 12px 9px 16px;
    border-bottom: 1px solid $border-color;
    align-items: center;

    .service-icon {
      display: block;
      width: 32px;
      min-width: 32px;
      height: 32px;
      background: url("assets/images/service.svg") 50% no-repeat;
      background-size: 100%;
      margin-right: 10px;
    }

    .service-name {
      font-size: 16px;
      line-height: 22px;
      flex: 1;
      font-weight: 700;
    }

    .close-icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-size: 100%;
      cursor: pointer;
      transition: all 0.3s ease-in;
      @media screen and (min-width: 1200px) {
        &:hover{
          background-color: $border-color;
          transition: all 0.3s ease-in;
        }
      }
      &:before{
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        background: url("@/assets/images/arrow.png") 50% no-repeat;
        background-size: 100%;
      }
    }
  }

  > .content {
    height: 300px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 10px;
    @media screen and (max-width: 1200px) {
      overflow-y: scroll;
    }
    @media screen and (max-width: 576px) {
      height: calc(100vh - 300px);
    }
  }

  > .footer {
    display: flex;
    border-top: 1px solid $border-color;
    padding: 8px 10px;

    textarea {
      flex: 1;
      resize: none;
      border: none;
      height: 40px;
      padding-top: 8px;
      padding-bottom: 8px;
      box-sizing:border-box;
      font-size: 16px;
      font-family: -apple-system,BlinkMacSystemFont,"Segoe UI Adjusted","Segoe UI","Liberation Sans",sans-serif;
      &:focus, &:focus-visible {
        outline: none;
      }
    }

    button {
      border: none;
      background: none;
      padding: 8px 12px;
      font-size: 16px;
      color: $primary-color;
      cursor: pointer;
      border-radius: 12px;
      transition: all 0.3s ease-in;
      &:disabled {
        cursor: not-allowed;
        &:hover {
          background-color: #ffffff;
        }
      }
      @media screen and (min-width: 1200px) {
        &:hover {
          background-color: $border-color;
          transition: all 0.3s ease-in;
        }
      }
    }

    button:disabled {
      color: $border-color;
    }
  }

  .loading-indicator {
    display: inline-flex;
    gap: 0.5rem;
    border-radius: 12px;
    padding: 16px 16px;
    background: $border-color;
    margin-bottom: 7%;
    span{
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    span:nth-child(1){
      background: #dedede;
      animation: loading 1.5s linear infinite;
    }
    span:nth-child(2){
      background: #dedede;
      animation: loading 1.5s linear infinite 0.5s;
    }
    span:nth-child(3){
      background: #dedede;
      animation: loading 1.5s linear infinite 1s;
    }
  }

  @keyframes loading {
    0% {
      background: #dedede;
    }
    50% {
      background: #9e9e9e;
    }
    100% {
      background: #dedede;
    }
  }

  .date-wrapper{
    display: flex;
    justify-content: center;
    margin: 10px 0;
    .date-box{
      padding: 4px 32px;
      color: #767676;
      background: #f6f6f6;
      text-align: center;
      font-size: 12px;
      border-radius: 12px;
    }
  }

  .message {
    display: flex;
    margin-bottom: 7%;
    flex-direction: row-reverse;
    align-items: end;

    .message__body {
      font-size: 14px;
      line-height: 20px;
      background: $primary-color;
      white-space: break-spaces;
      color: #fff;
      border-radius: 12px;
      padding: 12px 16px;
      max-width: 300px;
      word-break: break-word;
    }

    .message__time {
      font-size: 12px;
      line-height: 18px;
      color: #bfbfbf;
      margin: 0 6px;
    }

    &.message--reply {
      flex-direction: row;

      .message__body {
        color: #000;
        background: #f6f6f6;
      }
    }
  }
}

#chatbox.hide {
  .chat-icon {
    background: #0047ff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 54px;
    width: 54px;
    border-radius: 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    animation: zoom-out 0.3s ease forwards;
    img {
      height: 24px;
    }

    &:hover {
      animation: zoom-in 0.3s ease forwards;
    }
  }
}

@keyframes zoom-in {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

@keyframes zoom-out {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

</style>
